import api from './api';
import { configureStore } from './core/store';

const setToken = (token?: string) => api.setUserToken(token);
const { store, persistor } = configureStore(setToken);

export { store, persistor };
export default { store, persistor };
